import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { NavigationBar } from '../components/layout/NavigationBar';                     // Navbar component
import { Jumbotron } from '../components/layout/Jumbotron';                             // Jumbotron component
import { Layout } from '../components/layout/Layout';                            // Layout component

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} component={(props) => (
        localStorage.getItem('user') ? 
            (<div>
                <React.Fragment>
                    <NavigationBar/>
                        <Jumbotron/>
                            <Layout>
                                <Component {...props} />
                            </Layout>
                </React.Fragment>
            </div>
            ) :
            (<Redirect to="/"/>)
    )}/>
)

export default (PrivateRoute)
